import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    base: ["w-full"],
    topComponentsWrapper: ["flex justify-between"],
    titleWrapper: ["flex flex-col gap-4"],
    title: ["text-default-800 flex items-center gap-3"],
    actionComponentWrapper: ["flex items-start gap-3"],
    childrenWrapper: ["flex flex-wrap items-center justify-between gap-4"],
  },
});
